module.exports = __webpack_public_path__ + "img/fit-for-fun.eaf58a14.jpg";